export default __webpack_public_path__ + "static/media/cryptoPhone.daaad34d.svg";